import React, { useEffect, useContext, useState } from "react";
import categoriasRRHHContext from "../../context/categoriasRRHHContext/categoriasRRHHContex";

import CategoriasRRHHList from "../../components/CategoriasRRHHList/CategoriasRRHHList";
import SearchInput from "../../components/searchInput/SearchInput";

// Alertas
import Swal from 'sweetalert2'

import './CategoriasRRHH.css';
import AbmCategoriasRRHH from "../../components/abmCategoriasRRHH/abmCategoriasRRHH";
import authContext from "../../context/authentication/authContex";

const CategoriasRRHH = () =>{

    const [filter,setFilter] = useState('');
    const [showAbm, setShowAbm] = useState(false);
    const [categoriaToEdit, setCategoriaToEdit] = useState({});

    const catRRHHContext = useContext(categoriasRRHHContext);
    const {categoriasRRHHList, agregarCategoriasRRHH, actualizarCategoriasRRHHFromSoftland} = catRRHHContext;

    const { usuario, hasWebServiceConfigured } = useContext(authContext);

    const getDataFromSoftland = async() => {
      if(hasWebServiceConfigured){
        Swal.fire({
          title: 'Desea actualizar la lista?',
          text: "Se traeran los datos de Softland para sobreescribir la base de datos de la aplicación.",
          showCancelButton: true,
          confirmButtonText: 'Actualizar',
          cancelButtonText: 'No, cancelar',
          showLoaderOnConfirm: true,
          preConfirm: async () => {
              return await actualizarCategoriasRRHHFromSoftland()
              .then(response => {
                console.log("response");
                console.log(response);
                
                if (!response.status) {
                  throw new Error(response.msg)
                }
                return response;
              })
              .catch(error => {
                Swal.showValidationMessage(
                  `Request failed: ${error}`
                )
              })
          },
          allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
          if (result.isConfirmed) {
                  Swal.fire(
                      'Actualizado!',
                      'La base de datos ha sido actualizada correctamente.',
                      'success'
                  )
          }
        })
      }else{
        Swal.fire({
          title:"No es posible actualizar las Categorias RRHH!", 
          text:"No se ha configurado una conexión con un sistema externo, utilice el botón + en azul para dar de alta las categorias RRHH en forma manual o mediante una planilla xlsx. Si desea configurar un sistema externo comuníquese con el soporte de XertuX",
          confirmButtonColor:'#3d4d87',
        });
      }
    }

    const handleEditCategoria = (categoria) =>{
      setCategoriaToEdit(categoria);
      setShowAbm(true);
    }

    useEffect(()=>{
        const funcionAsync = async() =>{
        }
    },[])

    return <div className="categoriasRRHH">
        <SearchInput buscar={setFilter} filter={filter}/>
        <button className="agregar-productos-btn" onClick={()=>setShowAbm(true)}> + </button>
        <button className="getCategoriesFromSoftlandBtn" onClick={getDataFromSoftland}>Actualizar Categorías</button>
        <CategoriasRRHHList categoriasList={categoriasRRHHList} filter={filter} handleEditCategoria={handleEditCategoria}/>
        {showAbm && <AbmCategoriasRRHH setShowAbm={setShowAbm} categoriaToEdit={categoriaToEdit} setCategoriaToEdit={setCategoriaToEdit}/>}
    </div>

}

export default CategoriasRRHH;